import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import api from "../lib/api";
import { errMsg, inputCls } from "../components/admin/ui";
import { toast } from "sonner";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold text-[#F5F3ED] mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>{title}</h1>
        {children}
        <p className="text-xs text-center text-[#A8A8AD] mt-6">
          <Link to="/login" data-testid="back-to-login-link" className="text-[#D4AF37] hover:underline">← Kembali ke halaman masuk</Link>
        </p>
      </div>
    </div>
  );
}

const btn = "w-full bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] disabled:opacity-50 transition-colors font-bold rounded-sm py-2.5";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <Shell title="Lupa Password">
      {sent ? (
        <div data-testid="forgot-sent-message" className="bg-[#202127] border border-[#35C78A] rounded-lg p-6 text-sm text-[#F5F3ED] leading-relaxed">
          Jika <b>{email}</b> terdaftar, kami sudah mengirim link reset password ke email tersebut. Link berlaku 1 jam. Periksa juga folder spam.
        </div>
      ) : (
        <form onSubmit={submit} className="bg-[#202127] border border-[#35353B] rounded-lg p-6 space-y-4">
          <p className="text-sm text-[#A8A8AD]">Masukkan email akun Anda. Kami akan mengirim link untuk membuat password baru.</p>
          <label className="block">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Email</span>
            <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </label>
          <button data-testid="forgot-submit-btn" type="submit" disabled={loading} className={btn}>{loading ? "Mengirim..." : "Kirim Link Reset"}</button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Konfirmasi password tidak sama"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password berhasil diubah. Silakan masuk.");
      navigate("/login");
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <Shell title="Reset Password">
        <div data-testid="reset-invalid-message" className="bg-[#202127] border border-[#F06464] rounded-lg p-6 text-sm text-[#F5F3ED]">
          Link reset tidak valid. <Link to="/forgot-password" className="text-[#D4AF37] hover:underline">Minta link baru</Link>.
        </div>
      </Shell>
    );
  }

  return (
    <Shell title="Buat Password Baru">
      <form onSubmit={submit} className="bg-[#202127] border border-[#35353B] rounded-lg p-6 space-y-4">
        <label className="block">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Password baru (min. 8 karakter)</span>
          <input data-testid="reset-password-input" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} />
        </label>
        <label className="block">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Ulangi password baru</span>
          <input data-testid="reset-password-confirm-input" type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} />
        </label>
        <button data-testid="reset-submit-btn" type="submit" disabled={loading} className={btn}>{loading ? "Menyimpan..." : "Simpan Password"}</button>
      </form>
    </Shell>
  );
}
